module.exports = __webpack_public_path__ + "static/media/Jupyter_logo.svg.b2a0eae5.png";